import { Component, OnDestroy, OnInit } from "@angular/core";
import { ResultStatus } from "@app/core/models/result-status";
import { NotificationService } from "@app/core/services/notification.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { HelperService } from "@app/core/services/helper.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AgentDetailComponent } from "@app/modules/agent/pages/agent-detail/agent-detail.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { HttpParams } from "@angular/common/http";
import { ManageRecommendationsComponent } from '@app/modules/agent/pages/manage-recommendations/manage-recommendations.component';
import { RecommendAgentComponent } from '@app/modules/agent/pages/recommend-agent/recommend-agent.component';
import { ChatEmitterService } from '@app/core/services/chat-emitter.service';
import { AppConfig } from '@app/core/Utilities/app-config.service';

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class NotificationComponent implements OnInit, OnDestroy {
  notificationList = [];
  isDataLoaded = false;
  bsModalRef: BsModalRef;
  constructor(
    private notificationService: NotificationService,
    private sanit: DomSanitizer,
    private toaterService: ToastrService,
    private helperService: HelperService,
    private modalService: BsModalService,
    private chatEmitterService: ChatEmitterService,
    private appConfig: AppConfig,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.getNotifications();
    if (this.chatEmitterService.notificationListSubscription === undefined) {
      this.chatEmitterService.notificationListSubscription = this.chatEmitterService.notificationCount.subscribe(
        (data) => {
          this.getNotifications();
          this.updateNotificationCount();
        }
      );
    }

    this.route.queryParams.subscribe((params) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.redirectUrl)) {
        let url = this.router.url.replace("#", "?");
        url = url.replace("/notification?redirectUrl=", "");
        url = decodeURIComponent(url);
        this.redirectToUrl(url);
      }
    });
  }

  ngOnDestroy() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  readNotification(id, isRead, redirectUrl) {
    if (!isRead) {
      this.notificationService
        .readNotification(id, true)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            if (!this.helperService.isUndefinedOrNullOrEmpty(redirectUrl)) {
              this.redirectToUrl(redirectUrl);
            }
            this.getNotifications();
            if (this.appConfig.SharedComponent.notificationCount > 0) {
              this.appConfig.SharedComponent.notificationCount--;
            }
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    } else if (!this.helperService.isUndefinedOrNullOrEmpty(redirectUrl)) {
      this.redirectToUrl(redirectUrl);
    }
  }

  updateQueryParams() {
    // changes the route without moving from the current view or
    // triggering a navigation event,
    this.router.navigate([], {
      relativeTo: this.route
    });
  }

  redirectToUrl(redirectUrl) {
    if (redirectUrl.includes("http")) {
      window.open(redirectUrl, "_blank");
    } else {
      let httpParams;
      httpParams = new HttpParams({ fromString: redirectUrl.split("?")[1] });
      if (
        !this.helperService.isUndefinedOrNullOrEmpty(httpParams) &&
        !this.helperService.isUndefinedOrNullOrEmpty(httpParams.keys())
      ) {
        httpParams.keys().forEach((element) => {
          const elementValue = httpParams.get(element);
          if (element === "agentId" && redirectUrl.includes("agent/detail?agentId=")) {
            this.openModalWithComponent(+elementValue);
            return;
          } else if (element === "recommendationId" && redirectUrl.includes("recommendation/revise?recommendationId=")) {
            const initialState = {
              id: +elementValue
            };
            this.bsModalRef = this.modalService.show(
              RecommendAgentComponent,
              { initialState, backdrop: 'static', class: "modal-lg" }
            );
            this.subscribeModalHideEvent();
          }
        });
      } else if (redirectUrl === "manage-recommendation") {
        this.bsModalRef = this.modalService.show(
          ManageRecommendationsComponent, { backdrop: 'static', class: "modal-lg" }
        );
        this.subscribeModalHideEvent();
      } else {
        this.router.navigate([`/${redirectUrl}`]);
      }
    }
  }

  getNotifications() {
    this.notificationService.getNotifications().subscribe((result) => {
      this.isDataLoaded = true;
      if (result.Status === ResultStatus.Success) {
        this.notificationList = result.Data;
      } else {
        this.toaterService.error("something went wrong");
        this.notificationList = [];
      }
    });
  }

  updateNotificationCount() {
    this.notificationService.updateNotificationCount();
  }

  openModalWithComponent(agentID) {
    if (agentID > 0) {
      const initialState = {
        agentId: agentID,
      };

      this.bsModalRef = this.modalService.show(AgentDetailComponent, {
        initialState,
        backdrop: 'static',
        class: "modal-xl",
      });
      this.bsModalRef.content.closeBtnName = "Close";
      this.subscribeModalHideEvent();
    }
  }

  subscribeModalHideEvent() {
    this.modalService.onHide.subscribe((result) => {
      this.updateQueryParams();
      this.getNotifications();
    });
  }
}
